export default {
    data() {
        return {
            pt: {
                title: "Selecionar um Artista",
                sub_title: "Clique em um artista abaixo para configurar seu site",
                bt: "Novo Artista",
                search: "Procurar",
            },
            en: {
                title: "Select an Artist",
                sub_title: "Click on an artist below to set up your site",
                bt: "New Artist",
                search: "Search",
            },
            it: {
                title: "Seleziona un Artista",
                sub_title: "Clicca su un artista qui sotto per configurare il tuo sito",
                bt: "Nuovo Artista",
                search: "Cerca",
            }
        }
    }
}
